#@import Booking.Presenters.TextNotifications
#@import Booking.Views.Base
#@export Booking.Views.TextNotifications

class Booking.Views.TextNotifications extends Booking.Views.Base

  presenter: Booking.Presenters.TextNotifications

  templateName: 'text_notifications'

  events:
    'change input[type=checkbox]': 'toggle'

  canRender: ->
    @model.requireTextNotifications()

  render: ->
    Booking.Views.Base::render.apply(this, arguments)
    GIG?.Tooltip?.reloadBindings(document.body)
    this

  toggle: ->
    # this typeof check is needed for Checkout.
    # We use this view to render the text notifications, but we don't use the booker model there
    @model.toggleTextNotifications() if typeof @model.toggleTextNotifications is 'function'
